(function (Drupal) {
  Drupal.behaviors.howtoreachus = {
    attach: function (context, settings) {
      const list_items = document.querySelectorAll('.block-content-how_to_reach_us_block .field__items.field--name-field-lista-de-atencion > .field__item', context);
      if (!list_items) return;

      list_items.forEach((item, index) => {
        if (index==0) {
          appendButtonToModal(item)
        }
      });
      
      function appendButtonToModal(item) {
        const button_modal = document.createElement('button');
        button_modal.className = 'btn btn-border';
        button_modal.textContent = "¿Cómo llegar?";
        button_modal.setAttribute("data-bs-target", "#modal-location-map");
        button_modal.setAttribute("data-bs-toggle", "modal");
        item.appendChild(button_modal);
        button_modal.addEventListener("click", function(e) {          
          const modal = document.querySelector("#modal-location-map", context); 
          modal.classList.add("show")
        })
      }
    }
  };
})(Drupal);
